class PasswordField {
  constructor(el) {
    this.container = el
    this.input = this.container.querySelector('input')
    this.toggleButton = this.container.querySelector('button')

    this.showHidePassword = this.showHidePassword.bind(this)
    this.init()
  }

  showHidePassword() {
    if (!this.input) return
    if (this.input.type === 'password') {
      this.input.type = 'text'
    } else {
      this.input.type = 'password'
    }
  }

  init() {
    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', this.showHidePassword)
    }
  }
}

const passwordFieldInit = {
  init() {
    const wrapperEl = document.querySelectorAll('.password-field')
    Array.from(wrapperEl).forEach(form => new PasswordField(form))
  },
}

export default passwordFieldInit
